import { useEffect, useRef } from 'react';

type Props = {
  value: string;            // 10 raw digits, no prefix
  onChange: (v: string) => void;
  autoFocus?: boolean;
};

export function PhoneInput({ value, onChange, autoFocus }: Props) {
  const ref = useRef<HTMLInputElement>(null);
  useEffect(() => { if (autoFocus) ref.current?.focus(); }, [autoFocus]);

  const display = value.length > 5 ? `${value.slice(0, 5)} ${value.slice(5)}` : value;

  return (
    <div className="flex items-stretch border border-[var(--color-border)] rounded-[var(--radius-md)] bg-white overflow-hidden">
      <div className="flex items-center gap-1.5 px-3 border-r border-[var(--color-border)] text-sm font-semibold text-[var(--color-text)]">
        <span className="text-base">🇮🇳</span>
        <span>+91</span>
      </div>
      <input
        ref={ref}
        inputMode="numeric"
        autoComplete="tel-national"
        value={display}
        onChange={(e) => onChange(e.target.value.replace(/\D/g, '').slice(0, 10))}
        placeholder="98765 43210"
        className="flex-1 border-none outline-none px-3 py-3 text-base bg-transparent tracking-wider"
      />
    </div>
  );
}
